import HookUseCaptcha from './fake-component'
import {useCaptcha} from './hook-use-captcha'

export {useCaptcha}
export default HookUseCaptcha
